import React from 'react';
import '../../styling/App.scss';
import Typography from "@mui/material/Typography";
import {List, ListItem, ListItemIcon, ListItemText, Stack} from "@mui/material";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ImportantText from "../ImportantText";


const Home = () => {
    return (
        <Stack direction="column" padding="40px" gap="20px">
            <Stack direction="column">
                <Typography variant="h4" paddingBottom="20px">
                    Cine suntem?
                </Typography>
                <Typography variant="body1" padding="10px 0">
                    Compania Aventură & Călătorii își are originile în anul 2010, când un profesor de geografie
                    pasionat de explorarea lumii a decis să transforme bucuria călătoriilor într-o misiune dedicată
                    educației. Astfel a luat naștere o <ImportantText>firmă de turism specializată în excursii școlare
                    și programe
                    pentru elevi</ImportantText>, construită pe dorința de a oferi tinerilor <ImportantText>experiențe
                    autentice și memorabile</ImportantText>.

                </Typography>
                <Typography variant="body1" padding="10px 0">
                    De-a lungul anilor, datorită <ImportantText>profesionalismului și angajamentului față de
                    calitatea serviciilor</ImportantText>, compania a devenit <ImportantText>liderul numărul 1 în Brașov
                    în organizarea excursiilor dedicate elevilor și activităților educaționale de turism</ImportantText>.
                </Typography>
                <Typography variant="body1" padding="10px 0">
                    În timp, am extins direcțiile noastre de lucru pentru a răspunde cerințelor unei game tot mai
                    variate de călători. Astăzi, portofoliul nostru include excursii, circuite și sejururi pentru
                    adulți și seniori, păstrând aceeași valoare fundamentală care a definit compania încă de la
                    început: fiecare excursie este însoțită de un ghid profesionist. Indiferent că este vorba despre
                    elevi, adulți sau seniori, <ImportantText>un ghid dedicat asigură informații de calitate, siguranță
                    și o experiență completă</ImportantText>..
                </Typography>
                <Typography variant="body1" padding="10px 0">
                    Un moment important în evoluția companiei l-a reprezentat anul 2019, când ne-am dezvoltat
                    infrastructura prin crearea <ImportantText>propriei flote de autocare</ImportantText>. Dispunem acum
                    de vehicule moderne, conduse de șoferi experimentați, oferind astfel <ImportantText> standarde
                    superioare de confort, siguranță și punctualitate</ImportantText>.
                </Typography>
                <Typography variant="body1" padding="10px 0">
                    În prezent, Aventura & Călătorii oferă o <ImportantText>gamă complexă de servicii
                    turistice:</ImportantText>
                </Typography>
                <List>
                    <ListItem key="0">
                        <ListItemIcon>
                            <LocationCityIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="excursii și programe educaționale pentru elevi"/>
                    </ListItem>
                    <ListItem key="0">
                        <ListItemIcon>
                            <LocationCityIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="excursii, circuite și sejururi pentru grupuri de adulți și seniori"/>
                    </ListItem>
                    <ListItem key="0">
                        <ListItemIcon>
                            <DirectionsBusIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText primary="închirieri autocare pentru deplasări naționale și internaționale"/>
                    </ListItem>
                    <ListItem key="0">
                        <ListItemIcon>
                            <DirectionsBusIcon color="primary"/>
                        </ListItemIcon>
                        <ListItemText
                            primary="transport pentru evenimente, team-building-uri și activități corporate"/>
                    </ListItem>
                </List>
                <Typography variant="body1" padding="10px 0">
                    Începând cu acest an, ne propunem să adăugăm în portofoliu și organizarea completă de
                    team-building-uri, precum și programe dedicate turiștilor străini. Ne dorim să le oferim
                    <ImportantText>o perspectivă autentică asupra României</ImportantText>, punând în valoare frumusețea
                    simplă și nealterată a satului românesc.
                </Typography>
                <Typography variant="body1" padding="10px 0">
                    Cu peste un deceniu de experiență, pasiune și profesionalism, rămânem dedicați misiunii noastre:
                    <ImportantText>să transformăm fiecare călătorie într-o poveste memorabilă.</ImportantText>
                </Typography>
            </Stack>
        </Stack>

    );
}

export default Home;
